import { createGraphQLClientFactory } from './create';
import { GraphQLRequestClientFactory } from '@sitecore-jss/sitecore-jss-nextjs/graphql';
import { loadRuntimeConfig } from 'lib/runtime-config/loadRuntimeConfig';

// The GraphQLRequestClientFactory serves as the central hub for executing GraphQL requests within the application

// Resolve config lazily so build-time imports do not fail before runtime config is available.
const clientFactory: GraphQLRequestClientFactory = (config) =>
  createGraphQLClientFactory(loadRuntimeConfig())(config);

export default clientFactory;
